import React from 'react';
export function Header() {
  return <header className="w-full py-6 px-6 md:px-12 flex items-center justify-between z-40 relative border-b border-zinc-800/50 bg-zinc-950/80 backdrop-blur-sm sticky top-0" data-id="element-38">
      <div className="flex items-center gap-3" data-id="element-39">
        <img src="https://cdn.magicpatterns.com/uploads/8CfYW3AghwKD7VWCJFg2Vy/Untitled_design.png" alt="BloomMind Logo" className="h-10 w-auto mix-blend-screen" data-id="element-40" />
      </div>
      <nav data-id="element-41">
        <a href="#faq" className="text-sm font-medium text-zinc-400 hover:text-teal-400 transition-colors" data-id="element-42">
          FAQ
        </a>
      </nav>
    </header>;
}